import CaseStageComponent from '../../Components/Masters/CaseStage/CaseStageComponent'

function CaseStagePage() {
    return (
        <CaseStageComponent/>
    )
}

export default CaseStagePage